module.exports = __webpack_public_path__ + "static/img/cobija.976f30c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/cobija.jpg
// module id = iSGf
// module chunks = 1